import React from "react";

const Loading = ({ className, label }) => (
  <div className={`Loading ${className}`} role="alert" aria-live="polite">
    <div className="Loading-spinner"></div>
    <p className="Loading-label f-scale-body u-mt1">{label}</p>
  </div>
);

export default Loading;
